import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { get } from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CucmLicenseOptimizationOverviewComponent } from './cucm-license-optimization-overview/cucm-license-optimization-overview.component';

@Component({
  selector: 'ziro-cucm-license-optimization',
  templateUrl: './cucm-license-optimization.component.html',
  styleUrls: ['../../reporting.scss'],
  standalone: false,
})
export class CucmLicenseOptimizationComponent implements OnInit, OnDestroy {
  private breadcrumbsService = inject(BreadcrumbsService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  @ViewChild(CucmLicenseOptimizationOverviewComponent)
  childComponent: CucmLicenseOptimizationOverviewComponent;
  licenseTier = decodeURIComponent(get(this.route, 'snapshot.params.licenseTier'));
  childComponentLicenseReport: CucmLicenseOptimizationOverviewComponent;
  private _subs = new Subscription();

  ngOnInit(): void {
    this._setLicenseTier();
    const routeChange = this.router.events.subscribe(this._setLicenseTier);
    this._subs.add(routeChange);
  }

  ngOnDestroy(): void {
    this.breadcrumbsService.clearBreadcrumbs();
    this._subs.unsubscribe();
  }

  onRouterOutletActivate(event: CucmLicenseOptimizationOverviewComponent): void {
    this.childComponentLicenseReport = event;
  }

  private _setLicenseTier: () => void = () => {
    const tier = this.route.firstChild?.snapshot?.params['licenseTier'];
    if (tier) {
      this.licenseTier = decodeURIComponent(tier);
    }
  };
}
